import React from 'react';
import { Container } from 'reactstrap';
import { Subtitle, Description, Titlespan2 } from '../../components/title/index';
import CarouselSlider from './testimonial';
import './testimonial.scss';

function Testimonial() {
    return (<></>)
    return (
        <section className="testimonial-wrapper gradient-color" id="testimonial">
            <Container>
                <div className="main-title-wrapper">
                    <Subtitle
                        Class="site-subtitle gradient-color"
                        Name="testimonial"
                    />
                    <Titlespan2
                        Class="sitemain-subtitle"
                        Name="Client Feedback"
                        Label=""
                    />
                    <Description
                        Class="site-dec"
                        Name="We're proud to have many happy clients who have shared their experience here"
                    />
                </div>
                <CarouselSlider />
            </Container>
        </section>
    );
}

export default Testimonial;
